import * as React from "react"
import albedo from '@albedo-link/intent'

import Layout from "../components/layout"
import Seo from "../components/seo"
import { TOKENS } from "../utils/constants"
import { StaticImage } from "gatsby-plugin-image"
import { usePublicKey } from "../hooks/usePublicKey"
import { useStellarAccount } from "../hooks/useStellarAccount"

const InnPage = () => {
  const { publicKey } = usePublicKey()
  const { energy, money, berries, meat, food, reloadAccount } =
    useStellarAccount(publicKey)


  const getARoom = async () => {
    albedo.pay({
      network: "testnet",
      asset_code: TOKENS.MONEY.CODE,
      asset_issuer: TOKENS.MONEY.ISSUER,
      destination: TOKENS.ENERGY.ISSUER,
      amount: Number(100).toFixed(7).toString(),
      submit: true
    })
    .then(res => { console.log(res);})
    .catch(console.log)
  };
  const cookBerries = async () => {
    albedo.pay({
      network: "testnet",
      asset_code: TOKENS.BERRY.CODE,
      asset_issuer: TOKENS.BERRY.ISSUER,
      destination: TOKENS.FOOD.ISSUER,
      amount: Number(10).toFixed(7).toString(),
      submit: true
    })
    .then(res => { console.log(res);})
    .catch(console.log)
  };
  const cookMeat = async () => {
    albedo.pay({
      network: "testnet",
      asset_code: TOKENS.MEAT.CODE,
      asset_issuer: TOKENS.MEAT.ISSUER,
      destination: TOKENS.FOOD.ISSUER,
      amount: Number(5).toFixed(7).toString(),
      submit: true
    })
    .then(res => { console.log(res);})
    .catch(console.log)
  };
  
  return <Layout>
    <Seo title="Inn" />
    <h2>The inn</h2>
    <div className="actions-layout">
      <div className="action-card sleep-action">
        <div className="action-description">
          Get a room and sleep
        </div>
        <div className="action-requirements">
          <strong>NO TOOLS REQUIRED</strong>
        </div>
        <div className="action-cost">
          <strong>-100</strong> <StaticImage src={"../images/migas.png"} width={48} alt={TOKENS.MONEY.CODE}/> {money && <strong>({Number(money.balance)})</strong>}
        </div>
        <div className="action-outcome">
          <strong>+10</strong> <StaticImage src={"../images/sleeping.png"} width={48} alt={TOKENS.ENERGY.CODE}/> {energy && <strong>({Number(energy.balance)})</strong>}
        </div>
        <div className="action-duration">
          <strong>50 min</strong>
        </div>
        <button onClick={getARoom}>DO</button>
      </div>
      <div className="action-card cook-berries-action">
        <div className="action-description">
          Use the kitchen to prepare a berries salad
        </div>
        <div className="action-requirements">
          <strong>NO TOOLS REQUIRED</strong>
        </div>
        <div className="action-cost">
          <strong>-10</strong> <StaticImage src={"../images/berries.png"} width={48} alt={TOKENS.BERRY.CODE}/> {berries && <strong>({Number(berries.balance)})</strong>}
        </div>
        <div className="action-outcome">
          <strong>+10</strong> <StaticImage src={"../images/food.png"} width={48} alt={TOKENS.FOOD.CODE}/> {food && <strong>({Number(food.balance)})</strong>}
        </div>
        <div className="action-duration">
          <strong>5 min</strong>
        </div>
        <button onClick={cookBerries}>DO</button>
      </div>
      <div className="action-card cook-meat-action">
        <div className="action-description">
          Use the kitchen to cook meat
        </div>
        <div className="action-requirements">
          <strong>NO TOOLS REQUIRED</strong>
        </div>
        <div className="action-cost">
          <strong>-5</strong> <StaticImage src={"../images/meat.png"} width={48} alt={TOKENS.MEAT.CODE}/> {meat && <strong>({Number(meat.balance)})</strong>}
        </div>
        <div className="action-outcome">
          <strong>+15</strong> <StaticImage src={"../images/food.png"} width={48} alt={TOKENS.FOOD.CODE}/> {food && <strong>({Number(food.balance)})</strong>}
        </div>
        <div className="action-duration">
          <strong>15 min</strong>
        </div>
        <button onClick={cookMeat}>DO</button>
      </div>
    </div>
    
  </Layout>
}

export default InnPage
